import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Help.css";

function HelpPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Help Page</h1>
                <p className="main-description">Welcome to the Help page!</p>
            </main>
        </div>
    );
}

export default HelpPage;